const pageNameKey = "newTransferConfigurationToClient";

export const newTransferConfigurationToClientEn = {
  [pageNameKey]: {
    success: "Structure was successfully saved!",
    error: "Failed to transfer: ",
    errorNodeStructure: "node structure",
    errorNodeStructureTooManyNodes:
      "Unable to update nodeset: nodeset size exceeds maximum number of nodes (50000).",
    errorDashboards: "dashboards",
    errorAlarms: "alarm profiles",
  },
};

export const newTransferConfigurationToClientPtBr = {
  [pageNameKey]: {
    success: "A estrutura foi salva com sucesso!",
    error: "Falha ao transferir: ",
    errorNodeStructure: "estrutura de nós",
    errorNodeStructureTooManyNodes:
      "Não foi possível atualizar o conjunto de nós: o tamanho do conjunto de nós excede o número máximo de nós (50000).",
    errorDashboards: "painéis",
    errorAlarms: "perfis de alarme",
  },
};

export const newTransferConfigurationToClientDe = {
  [pageNameKey]: {
    success: "Die Konfiguration wurde erfolgreich gespeichert!",
    error: "Übertragung fehlgeschlagen: ",
    errorNodeStructure: "Knotenstruktur",
    errorNodeStructureTooManyNodes:
      "Die Knotenstruktur kann nicht aktualisiert werden: Die Größe der Knotenstruktur überschreitet die maximale Anzahl von Knoten (50000).",
    errorDashboards: "Dashboards",
    errorAlarms: "Alarmprofile",
  },
};

export const newTransferConfigurationToClientZhHans = {
  [pageNameKey]: {
    success: "结构已成功保存！",
    error: "传输失败：",
    errorNodeStructure: "节点结构",
    errorNodeStructureTooManyNodes:
      "无法更新节点集：节点集大小超过最大节点数（50000）。",
    errorDashboards: "仪表盘",
    errorAlarms: "警报配置文件",
  },
};

export const newTransferConfigurationToClientIt = {
  [pageNameKey]: {
    success: "La struttura è stata salvata con successo!",
    error: "Trasferimento fallito: ",
    errorNodeStructure: "struttura nodi",
    errorNodeStructureTooManyNodes:
      "Impossibile aggiornare il nodeset: la dimensione del nodeset supera il numero massimo di nodi (50000).",
    errorDashboards: "dashboard",
    errorAlarms: "profili di allarme",
  },
};

export const newTransferConfigurationToClientEs = {
  [pageNameKey]: {
    success: "¡La estructura se guardó correctamente!",
    error: "Error al transferir: ",
    errorNodeStructure: "estructura de nodos",
    errorNodeStructureTooManyNodes:
      "No se puede actualizar el conjunto de nodos: el tamaño del conjunto de nodos supera el número máximo de nodos (50000).",
    errorDashboards: "paneles",
    errorAlarms: "perfiles de alarma",
  },
};

export const newTransferConfigurationToClientNl = {
  [pageNameKey]: {
    error: "Overdracht mislukt: ",
    errorAlarms: "alarmprofielen",
    errorDashboards: "Dashboards",
    errorNodeStructure: "nodestructuur",
    errorNodeStructureTooManyNodes:
      "Kan nodeset niet bewerken: nodeset-grootte overschrijdt het maximale aantal nodes (50000).",
    success: "Structuur is succesvol opgeslagen!",
  },
};

export const newTransferConfigurationToClientTr = {
  [pageNameKey]: {
    error: "Aktarılamadı:",
    errorAlarms: "alarm profilleri",
    errorDashboards: "gösterge tabloları",
    errorNodeStructure: "düğüm yapısı",
    errorNodeStructureTooManyNodes:
      "Düğüm kümesi güncellenemiyor: Düğüm kümesi boyutu maksimum düğüm sayısını (50000) aşıyor.",
    success: "Yapı başarıyla kaydedildi!",
  },
};
